import styles from './bulletin.module.sass';

import type { ReactNode } from 'react';

export const Bulletin = ({
  isLoading,
  children,
}: {
  isLoading: boolean;
  children: ReactNode[];
}) => {
  if (isLoading) {
    return null;
  }
  return (
    <div className="flex justify-center">
      <div className={styles.bulletin}>{children}</div>
    </div>
  );
};

interface PromotionItemProps {
  imageUrl: string;
  backgroundColor: string;
  color?: string;
  title: string;
  subTitle: string;
  uri: string | undefined;
  onClick: () => void;
}

export const BulletinItem = ({
  title,
  subTitle,
  imageUrl,
  uri,
  color = '#000000',
  backgroundColor,
  onClick,
}: PromotionItemProps) => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={uri}
      className={styles.item}
      onClick={onClick}
      style={{
        backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
        backgroundColor,
        color,
      }}
    >
      <div>{title}</div>
      <div>{subTitle}</div>
    </a>
  );
};
